export function getSectionModel(roofType, collarSupport, middlePurlinSupport, b1, b2, b3, b4, h1, h2, s) {
    if (![b1, h1, h2].every(value => value > 0)) {
        return;
    }

    if (b2 < 0) {
        return;
    }

    if (s > 75 || s < 10) {
        return;
    }
    const tanS = h1 / (b1 / 2);
    const h3 = b2 * tanS;
    const node1 = {
        label: 'N1',
        coords: [0, 0, 0],
    };
    const node2 = {
        label: 'N2',
        coords: [b2, 0, h3],
    };
    const node3 = {
        label: 'N3',
        coords: [b2 + h2 / tanS, 0, h3 + h2],
    };
    const node4 = {
        label: 'N4',
        coords: [b2 + b4, 0, h3 + b4 * tanS],
    };
    const node5 = {
        label: 'N5',
        coords: [b2 + b1/2, 0, h3 + h1],
    };
    const node6 = {
        label: 'N6',
        coords: [b2 + b1 - b4, 0, h3 + b4 * tanS],
    };
    const node7 = {
        label: 'N7',
        coords: [b2 + b1 - h2 / tanS, 0, h3 + h2],
    };
    const node8 = {
        label: 'N8',
        coords: [b2 + b1, 0, h3],
    };
    const node9 = {
        label: 'N9',
        coords: [2 * b2 + b1, 0, 0],
    };

    const nodes = [node1, node2, node3, node4, node5, node6, node7, node8, node9];
    nodes.forEach(node => {
        node.fixity = {x: 'free', z: 'free', ry: 'free'};
    });

    const member1 = {
        label: 'E1',
        start_node: 'N1',
        end_node: 'N5',
        hinges: [false, false]
    };

    const member2 = {
        label: 'E2',
        start_node: 'N5',
        end_node: 'N9',
        hinges: [true, false]
    };

    const member3 = {
        label: 'E3',
        start_node: 'N3',
        end_node: 'N7',
        hinges: [true, true]
    };

    const pA = [0, 0, 0];
    const pB = [b2, 0, 0];
    const pC = [b2 + b4, 0, 0];
    const pD = [b2 + b4 + b3, 0, 0];
    const pE = [b2 + b1, 0, 0];
    const pF = [2 * b2 + b1, 0, 0];
    const pG = [0, 0, h3];
    const pH = [0, 0, h3 + h2];
    const pI = [0, 0, h3 + h1];


    switch (roofType) {
        case 'krokvovy':
            node2.fixity = {x: 'fixed', ry: 'free', z: 'fixed'};
            node8.fixity = {x: 'fixed', ry: 'free', z: 'fixed'};
            return {
                nodes: [node1, node2, node5, node8, node9],
                members: [member1, member2],
                dims: [
                    { points: [pA, pB, pE, pF], extrude: -1},
                    { points: [pG, pI], extrude: 1}
                ]
            };

        case 'hambalkovy':
            node2.fixity = {x: 'fixed', ry: 'free', z: 'fixed'};
            node8.fixity = {x: 'fixed', ry: 'free', z: 'fixed'};
            if (collarSupport === 'pinned') {
                node3.fixity = {x: 'fixed', ry: 'free', z: 'free'};
            }
            return {
                nodes: [node1, node2, node3, node5, node7, node8, node9],
                members: [member1, member2, member3],
                dims: [
                    {points: [pA, pB, pE, pF], extrude: -1},
                    { points: [pG, pH], extrude: 1},
                    { points: [pG, pI], extrude: 1.5},
                ]
            };

        case 'vrcholova-vaznice':
            node2.fixity = {x: 'fixed', ry: 'free', z: 'fixed'};
            node5.fixity = {x: 'free', ry: 'free', z: 'fixed'};
            node8.fixity = {x: 'fixed', ry: 'free', z: 'fixed'};
            return {
                nodes: [node1, node2, node5, node8, node9],
                members: [member1, member2],
                dims: [
                    { points: [pA, pB, pE, pF], extrude: -1},
                    { points: [pG, pI], extrude: 1},
                ]
            };

        case 'stredove-vaznice':
            node2.fixity = {x: 'fixed', ry: 'free', z: 'fixed'};
            node4.fixity = {x: 'free', ry: 'free', z: 'fixed'};
            node6.fixity = {x: 'free', ry: 'free', z: 'fixed'};
            node8.fixity = {x: 'free', ry: 'free', z: 'fixed'};
            if (middlePurlinSupport === 'pinned') {
                node8.fixity = {x: 'fixed', ry: 'free', z: 'fixed'};
            }
            return {
                nodes: [node1, node2, node4, node5, node6, node8, node9],
                members: [member1, member2],
                dims: [
                    { points: [pA, pB, pE, pF], extrude: -1.5},
                    { points: [pB, pC, pD, pE], extrude: -1},
                    { points: [pG, pI], extrude: 1},
                ]
            };

        case 'stredove-vaznice-klestina':
            node2.fixity = {x: 'fixed', ry: 'free', z: 'fixed'};
            node4.fixity = {x: 'free', ry: 'free', z: 'fixed'};
            node6.fixity = {x: 'free', ry: 'free', z: 'fixed'};
            node8.fixity = {x: 'free', ry: 'free', z: 'fixed'};
            if (middlePurlinSupport === 'pinned') {
                node8.fixity = {x: 'fixed', ry: 'free', z: 'fixed'};
            }
            return {
                nodes: [node1, node2, node3, node4, node5, node6, node7, node8, node9],
                members: [member1, member2, member3],
                dims: [
                    { points: [pA, pB, pE, pF], extrude: -1.5},
                    { points: [pB, pC, pD, pE], extrude: -1},
                    { points: [pG, pI], extrude: 1.5},
                    { points: [pG, pH], extrude: 1},
                ]
            };
    }
}
